<div class="metrics-toolbar-container">
    <div class="metrics-toolbar-nav">
        <h5>Performance Overview</h5>
        <div class="metrics-toolbar-menu-tabs">
    </div>
        <p-tabMenu [model]="metricsTabMenuItems" [activeItem]="activeTabItem"></p-tabMenu>
    </div>
    <div class="metrics-toolbar-filters-container">
        <div class="metrics-toolbar-filter" *ngIf="isGridSelected()">
            <label for="products"> <i class="fa-light fa-filter"></i>Products</label>
            <p-multiSelect
                #productsMultiselect
                inputId="products"
                [showToggleAll]="true"
                selectedItemsLabel="{0} products selected"
                optionLabel="name"
                optionValue="id"
                [(ngModel)]="selectedProducts"
                [options]="productOptions"
                placeholder="Select products"
                class="metrics-multiselect-input"
                [maxSelectedLabels]="0"
                (onChange)="onProductsChange($event)"
                (onPanelShow)="loadProductOptions()"
            >
            <!-- TODO: Once limit and name filter for product API uncomment this approach. -->
                <!-- <ng-template pTemplate="filter">
                    <div class="filter-tools-container">
                        <input
                            type="checkbox"
                            [checked]="areAllProductsSelected()"
                            (change)="toggleSelectAllProducts()"
                            class="metrics-select-all-checkbox"
                        />
                        <input
                            type="text"
                            class="p-inputtext metrics-text-input"
                            placeholder="Type to search products"
                            (input)="onProductFilter($event)"
                            autocomplete="off"
                        />
                        <button
                            type="button"
                            (click)="productsMultiselect.hide()"
                            class="p-multiselect-close p-link"
                        >
                            <span class="p-multiselect-close-icon pi pi-times"></span
                            ><span class="p-ink"></span>
                        </button>
                    </div>
                </ng-template> -->
            </p-multiSelect>
        </div>
        <div class="metrics-toolbar-filter" *ngIf="isGridSelected()">
            <label for="organization"> <i class="fa-light fa-filter"></i>Organizations</label>
            <p-multiSelect
                #organizationMultiselect
                selectedItemsLabel="{0} organizations selected"
                [options]="organizationOptions"
                [(ngModel)]="selectedOrganizations"
                optionLabel="name"
                optionValue="id"
                [maxSelectedLabels]="0"
                inputId="organization"
                class="metrics-multiselect-input"
                [showToggleAll]="false"
                placeholder="Select organizations"
                (onChange)="onOrganizationsChange($event)"
                (onPanelShow)="loadOrganizationsOptions()"
            >
                <ng-template pTemplate="filter">
                    <div class="filter-tools-container">
                        <input
                            type="checkbox"
                            [checked]="areAllOrganizationsSelected()"
                            (change)="toggleSelectAllOrganizations()"
                            class="metrics-select-all-checkbox"
                        />
                        <input
                            type="text"
                            class="p-inputtext metrics-text-input"
                            (input)="onOrganizationFilter($event)"
                            autocomplete="off"
                        />
                        <button
                            type="button"
                            (click)="organizationMultiselect.hide()"
                            class="p-multiselect-close p-link"
                        >
                            <span class="p-multiselect-close-icon pi pi-times"></span
                            ><span class="p-ink"></span>
                        </button>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>

        <div class="metrics-toolbar-filter">
            <label for="range"> <i class="fa-light fa-filter"></i>Date Range</label>
            <p-calendar
                icon="pi pi-calendar"
                class="datepicker-two-container"
                [showIcon]="true"
                [(ngModel)]="selectedDatesRange"
                selectionMode="range"
                [readonlyInput]="true"
                inputId="range"
                placeholder="00/00/0000"
                styleClass="metrics-table-calendar-input"
                (ngModelChange)="triggerDateChange($event)"
                (onClearClick)="setCurrentWeekRange()"
                (onTodayClick)="setCustomTodayRange()"
                [showButtonBar]="true"
            ></p-calendar>
        </div>
        <button
            (click)="emitFilters()"
            pButton
            icon="pi pi-search"
            class="p-button-secondary p-button-outlined metrics-toolbar-refresh-btn"
            pTooltip="Apply"
            tooltipPosition="top"
        ></button>
    </div>
</div>
